import u from '@/utility/utility';

export class BillOfLadingModel {
    public createdBy!: string;
    public createdDate!: string;
    public id!: number;
    public modifiedBy!: any;
    public modifiedDate!: any;
    public orderCodeId!: number;
    public orderId!: number;
    public transactionCode!: string;
    public productName!: string;
    public productImage!: string;
    public productAmount!: number;
    public numberOfPack!: number;
    public productNumber!: number;
    public packageType!: any;
    public status!: number;
    public statusDetail!: any;
    public uId!: number;
    public userName!: string;
    public weight!: string;
    public weightByVolume!: string;
    public volume!: string;
    public feeWeight!: number;
    public feeShipType!: number;
    public feeWeightAmount!: number;
}

export class Lading {
    public id: any = u.randomString(20);
    public binCode!: string;
    public productName!: string;
    public ProductImage!: string;
    public productAmount!: number;
    public numberOfPack!: number;
    public productNumber!: number;
    public isValid = true;
};